import classnames from 'classnames';

const className = classnames('pb-3', 'text-center');

interface Props {
  children: string;
  header: string;
}

const CardBackground = ({ children, header }: Props) => (
  <div className={className}>
    <h3 className="text-card-subtitle-color text-3xl">{header}</h3>
    {children}
  </div>
);

export default CardBackground;
